import {
  REMINDER_ATTEMPTS_MAPPER,
  REMINDER_HISTORY_STATUS_MAPPER,
} from "static/constants";

export const mapReminderHistoryStatus = (status) => {
  if (!status) return;

  const normalized = status.toLowerCase();
  const mappedStatus =
    Object.entries(REMINDER_HISTORY_STATUS_MAPPER).find(([, values]) =>
      values.includes(normalized)
    )?.[0] || "Unknown";

  return mappedStatus;
};

export const mapReminderCallType = (id) => REMINDER_ATTEMPTS_MAPPER[id] || id;
